import React from 'react';
import {
  FormGroup,
  Label,
  Select,
  ErrorMessage,
} from '../../styles';

interface Option {
  key: string | number;
  value: string | number;
  text: string;
}

interface MobileSelectProps {
  label: string;
  value: string | number;
  onChange: (value: string) => void;
  options: Option[];
  placeholder?: string;
  required?: boolean;
  error?: string;
  disabled?: boolean;
}

const MobileSelect: React.FC<MobileSelectProps> = ({
  label,
  value,
  onChange,
  options,
  placeholder = 'Selecione...',
  required,
  error,
  disabled,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <FormGroup>
      <Label required={required}>{label}</Label>
      <Select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        hasError={!!error}
      >
        <option value="">{placeholder}</option>
        {options.map((option) => (
          <option key={option.key} value={option.value}>
            {option.text}
          </option>
        ))}
      </Select>
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FormGroup>
  );
};

export default MobileSelect;
